import { render, staticRenderFns } from "./SundryCreditorItems.vue?vue&type=template&id=5641996a&scoped=true"
import script from "./SundryCreditorItems.vue?vue&type=script&lang=js"
export * from "./SundryCreditorItems.vue?vue&type=script&lang=js"
import style0 from "./SundryCreditorItems.vue?vue&type=style&index=0&id=5641996a&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5641996a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/flexiquote/flexiquote/uniqms-vue-app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5641996a')) {
      api.createRecord('5641996a', component.options)
    } else {
      api.reload('5641996a', component.options)
    }
    module.hot.accept("./SundryCreditorItems.vue?vue&type=template&id=5641996a&scoped=true", function () {
      api.rerender('5641996a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/sundrycreditor/SundryCreditorItems.vue"
export default component.exports